import React, {useState} from 'react';

import {useNavigate} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import {Box, Center, Group, Stack, Title} from '@mantine/core';

import {
    ButtonPrimary,
    ButtonPrimaryIcon,
    ButtonSecondary,
    ButtonSecondaryIcon,
    IconChevronLeft24,
    IconHelp24,
    IconHome24,
} from 'pac-ux-components';

import {useAccount} from 'hooks/useAccount';


export const SelectionPage = () => {
    const account = useAccount();

    const navigate = useNavigate();

    const [message, setMessage] = useState(false);

    const handleGoBack = () => {
        setMessage(false);
        navigate(`/reset-password/selection/${account.id}`);
    };

    const handleGoHome = () => {
        setMessage(false);
        navigate('/');
    };

    const handleCorporateAccount = () => {
        setMessage(true);
    };
    const handleUsernameAndPassword = () => {
        navigate(`/reset-password/request/${account.id}`);
    };

    return (
        <Box>
            <Title order={4}>{I18n.get('Reset Password')}</Title>
            {message ? (
                <Stack>
                    <Box py="sm">
                        <Box variant="h5">
                            Please, use your corporate sign-in provider to reset
                            your password
                        </Box>
                    </Box>
                    <Group py="sm" position="center">
                        <ButtonSecondaryIcon
                            onClick={handleGoBack}
                            icon={<IconChevronLeft24/>}
                        >
                            Back
                        </ButtonSecondaryIcon>
                        <ButtonPrimaryIcon
                            onClick={handleGoHome}
                            icon={<IconHome24/>}
                        >
                            Home
                        </ButtonPrimaryIcon>
                    </Group>
                </Stack>
            ) : (
                <Center>
                    <Stack position="center">
                        <Group py="sm">
                            <IconHelp24/>
                            <Box>How do you sign into NEXT Cloud?</Box>
                        </Group>

                        <Stack py="sm">
                            <Box>
                                <ButtonSecondary
                                    onClick={handleCorporateAccount}
                                >
                                    I use corporate account
                                </ButtonSecondary>
                            </Box>
                            <Center py="sm">or</Center>
                            <Box>
                                <ButtonPrimary
                                    onClick={handleUsernameAndPassword}
                                >
                                    I use email and password
                                </ButtonPrimary>
                            </Box>
                        </Stack>
                    </Stack>
                </Center>
            )}
        </Box>
    );
};
